import { Component, OnInit, EventEmitter, Output } from '@angular/core';
import { ModalService } from '../modals/modal.service';
import { CalendarFilterEvent } from '../models/calendar-filter-event.model';
import { SessionService } from '../services/session.service';

@Component({
    selector: 'calendar-filter',
    templateUrl: './calendar-filter.component.html',
    standalone: false
})
export class CalendarFilterComponent implements OnInit {

    @Output()filterCalendar: EventEmitter<CalendarFilterEvent> = new EventEmitter<CalendarFilterEvent>();

    public soonestAvail: string = 'Y';
    public apptNumber: number = null;

    constructor(private modalService: ModalService, private session: SessionService) {}

    ngOnInit() {
        if (this.session !== null) {
            this.apptNumber = this.session.numberOfAppointments;
        }
    }


    public applyFilter() {
        if (!isNaN(this.apptNumber) && this.apptNumber) {
            this.filterCalendar.emit(new CalendarFilterEvent(this.apptNumber, this.soonestAvail === 'Y'));
        } else {
            this.filterCalendar.emit(new CalendarFilterEvent(1, this.soonestAvail === 'Y'));
        }
    }

}
